export default __webpack_public_path__ + "static/media/show7.64289a1b.jpeg";